// extracted by css-extract-rspack-plugin
var _1 = "yuM7iutBMro4qCwY";
export { _1 as "wrapper" }
